import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import ChatBox from "./ChatBox";

const root = ReactDOM.createRoot(
  document.getElementById("root")
);

root.render(
  <React.StrictMode>
    <ChatBox />
  </React.StrictMode>
);